import { get,post,getAdv} from "@/api/request"

// 艺术家主页
export const getClass = params => get("/v1/home/pc/class/auctions", params)
export const getNews = params => get("/v1/home/pc/news", params)
export const getOther = params => get("/v1/home/pc/statics", params)
export const getRank = params => post("/v1/home/rank/top", params)
export const getSession = params => get("/v1/home/pc/specials", params)
// 拍卖预展与结果
export const getSessionNew = params => get("/v1/home/pc/specials/new", params)
export const getReport = params => post("https://tulu-app.artron.net/report/list", params)
export const getHome = params => get("/v1/home/pc/firstscreen", params)

export const getAdvData = params => getAdv("/getAdGroup", params)
export const getMemType = params => get("https://tulu-app.artron.net/zxp/manager", params)
export const getAdGroup = params => get("http://show.artron.net/getAdGroup?english=ecdhj529", params)

